import { ActionIcon } from '@mantine/core';
import { useTranslation } from 'react-i18next';

import {
    useAutoFormBuilding,
    useAutoFormStore
} from 'app/modules/wallforming/components/auto-form/hooks/useAutoFormBuilding';
import { isPlanarFacePoi } from 'app/modules/wallforming/components/scenes/objects/pois/utils/poiUtils';
import { usePlacementStore } from 'app/modules/wallforming/components/state-management/placement';

export const AnchorPlacementAction = () => {
    const { t } = useTranslation();
    const run = useAutoFormBuilding({ anchorsOnly: true });
    const isRunning = useAutoFormStore((state) => state.isRunning);
    const cancel = useAutoFormStore((state) => state.cancel);
    const isEnabled = usePlacementStore((state) => {
        const index = state.poiSelection.current.index;
        const poi = index === undefined ? undefined : state.pois[index]?.poi;
        return state.isPlacementDataInitialized && !!poi && isPlanarFacePoi(poi) && !state.isViewMode;
    });

    return (
        <ActionIcon
            aria-busy={isRunning}
            aria-label={isRunning ? t('labelCancelAutoForm') : t('labelPlaceAnchors')}
            className="pointer-events-auto action-icon-medium automated-placement-action-icon"
            data-testid="auto-anchor-button"
            disabled={isRunning ? !cancel : !isEnabled}
            variant="activated"
            onClick={() => (isRunning ? cancel?.() : void run())}
        >
            {isRunning ? 'stop' : 'auto_fix'}
        </ActionIcon>
    );
};
